import { render } from "./CrowdfundingGlossaryModal.vue?vue&type=template&id=749e1037"
import script from "./CrowdfundingGlossaryModal.vue?vue&type=script&lang=js"
export * from "./CrowdfundingGlossaryModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__